<script>
  import axios from 'axios'
  import { push } from 'svelte-spa-router'
  import Wrapper from '../Wrapper.svelte'
  import BoxCard from '../BoxCard.svelte'
  import { getURL } from '../../utils'
  import { bg_kb_red_small_png } from '../../image-base64'
  import LazyImage from '../LazyImage.svelte'
  import SearchInput from '../SearchInput.svelte'
  import { userStore, is } from '../../store'
  import Tracker from '../../tracking'

  let searchText = ''
  let searchResult = []

  let applications = [
    {
      visible: false,
      internal: true,
      active: true,
      name: 'Conveyor',
      type: 'external',
      // rootURL: '',
      rootURL: 'https://conveyor.support.flexlink.io/customer/login',
      icon: 'icon_267_conveyor.png'
    },
    {
      visible: true,
      internal: false,
      active: true,
      name: 'Software',
      type: 'external',
      rootURL: 'https://software.support.flexlink.io/customer/login',
      // rootURL: 'https://software.support.flexlink.io/support/home',
      icon: 'icon_controls_support.png'
    },
    {
      visible: false,
      internal: true,
      active: true,
      name: 'Robotics',
      type: 'external',
      rootURL: 'https://robotics.support.flexlink.io/customer/login',
      icon: 'icon_robot_support.png'
    },
    {
      visible: false,
      internal: true,
      active: true,
      name: 'Standard Controls',
      type: 'external',
      rootURL: 'https://standardcontrols.support.flexlink.io/customer/login',
      icon: 'icon_170_pcb.png'
    }
  ]

  function navigate (event) {
    const {type, ref} = event.detail
    if (type === 'component') {
      push(ref)
      return
    }
    if (type === 'external') {
      window.open(ref, '_blank')
      //const url = getURL(`/private/application/go?redirect=${encodeURIComponent(ref)}`)
      //console.log('[DEBUG] url', url)
      //axios.post(url)
      //  .then(res => {
      //    if (res.data != null) {
      //      console.log('[DEBUG] response:', res.data)
      //      window.location.href = res.data
      //    }
      //  })
    }
  }

  function search (key) {
    if (key.key !== 'Enter') {
      return
    }

    new Tracker().track('home.Search_knowledge_base')

    window.scrollTo({top: 0, right: 0, behavior: 'smooth'})

    push(`/search?term=${encodeURIComponent(searchText)}`)

    // window.location.href = `https://flexlink.freshdesk.com/support/search?term=${encodeURIComponent(searchText)}`

    /*
      TODO: implement search via Freshdesk API
        and results rendering in this portal ?

    freshSearch(searchText)
      .then(res => {
        if (res.data) {
          searchResult = res.data
        }
      })
      .catch(err => {
        console.log('search error', err)
      })
    */
  }

</script>

<div class="relative w-full flex items-stretch" style="min-height: 520px;">
  <LazyImage full={"static/img/bg_kb_red.png"} small={bg_kb_red_small_png} height={'520px'}
             grayscale="0%" brightness="1" />

  <div class="flex-grow flex flex-wrap items-stretch">

    <div class="w-full text-left px-20 my-auto flex-grow  py-16
                lg:w-1/2">

      <div class="text-white text-3xl font-light mb-12">
        Knowledge Base & Technical Support
      </div>

      <div class="mb-5">
        <SearchInput bind:searchText={searchText} on:search={() => search({key: 'Enter'})} />
      </div>
    </div>

    <div class="flex flex-wrap justify-center items-center mx-auto w-full
                lg:w-auto cards"
         style="max-width: 640px;">
      {#each applications as app}
        {#if !app.internal || app.internal && is($userStore.roles, 'internal')}
          <BoxCard active={app.active} title={app.name} height={260} width={320} ref={app.rootURL}
                   type={app.type} pic={app.icon}
                   on:navigate={navigate} />
        {/if}
      {/each}

    </div>

  </div>
</div>

<style>
    /*.icon-arrow-link::before {*/
    /*    content: "\E003";*/
    /*}*/

    .cards {
        /*width: auto;*/
    }
    @media (min-width: 1280px) {
        .cards {
            background-color: white;
            width: 640px;
        }
    }
</style>
